import { AxiosHelper } from "../axiosConfig";
import { ITag } from "../model/interface/tag";
import APIConstant from "../utils/apiConstant";

export const getTags = (tag: ITag) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_TAG_ALL, {
    params: {
      tagId: tag.tagId,
      name: tag.name,
      contentAreaId: tag.contentAreaId !== "" ? tag.contentAreaId : null,
      categoryId: tag.categoryId !== "" ? tag.categoryId : null,
      pageSize: tag.pageSize,
      pageNumber: tag.pageNumber,
      orderbyColumn: tag.orderbyColumn,
      sortDir: tag.sortDir,
      isActive: tag.isActive,
    },
  });
};

export const addTag = (tag: ITag) => {
  return AxiosHelper.axiosInstance().post(APIConstant.CMS_TAG, tag, {});
};

export const updateTag = (tag: ITag) => {
  return AxiosHelper.axiosInstance().put(APIConstant.CMS_TAG, tag, {});
};

export const deleteTag = (tagId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_TAG, {
    params: {
      id: tagId,
    },
  });
};

export const getTagById = (id) => {
  return AxiosHelper.axiosInstance().get(`${APIConstant.CMS_TAG}/${id}`);
};
